import { User } from "../@core/data/users";
import { Person } from "./person.model";

export class Supplier {
  id?: string;
  email?: string;
  mobile?: string;
  cardId?: string;

  fullName?: string;
  firstName?: string;
  lastName?: string;
  dob?: Date;
  dobYear?: number;
  dobMonth?: number;
  dobDay?: number;
  gender?: string;

  address?: string;
  description?: string;
  tax?: string;

  tags?: string[];
  coverUrl?: string;

  sourceType?: string; //video/images/document
  content?: string; //document
  videoUrl?: string; //video
  imagesUrl?: string[]; //images
  isDefault?: boolean;

  //List contacts
  contacts?: SupplierContacts[];

  //Overview
  saleQuantity?: number;
  saleAmount?: number;
  paidAmount?: number;
  debitAmount?: number;
  profitAmount?: number;
  noHistory?: number;

  initAmount?: number;
  lastAmount?: number;

  isSynced?: boolean;
  syncedOn?: Date;

  shopId?: string;
  shopIdArchived?: string;
  isArchived?: boolean;
  archivedId?: string;

  //default
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}

export class SupplierContacts {
  id?: string;
  role?: string;
  description?: string;
  person?: Person;

  //default
  timestamp?: number;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
}
